module.exports = __webpack_public_path__ + "static/img/s3.b793371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s3.png
// module id = 9a6O
// module chunks = 1